import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "d-flex justify-content-center",
  style: {"padding-top":"200px"}
}
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "btn btn-secondary" }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { class: "navbar fixed-bottom navbar-dark bg-dark d-flex justify-content-center" }
const _hoisted_8 = {
  class: "btn-group",
  role: "group"
}
const _hoisted_9 = {
  class: "container-fluid",
  style: {"padding-top":"130px"}
}
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-6" }
const _hoisted_12 = { class: "mx-5" }
const _hoisted_13 = { class: "text-dark" }
const _hoisted_14 = {
  class: "my-0 mx-5",
  style: {"font-size":"2em","font-weight":"300","color":"#33475b"}
}
const _hoisted_15 = { class: "col-6 col-lg-5 text-right col align-self-end" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "btn-group" }
const _hoisted_18 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "btn-group mr-1" }
const _hoisted_21 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_22 = { class: "btn-group mr-1" }
const _hoisted_23 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_24 = { class: "btn-group" }
const _hoisted_25 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = {
  class: "col-lg-3 col-md-3 col-sm-4 col-xs-12",
  style: {"padding-bottom":"100px"}
}
const _hoisted_28 = { class: "card" }
const _hoisted_29 = { class: "card-header" }
const _hoisted_30 = { class: "float-right" }
const _hoisted_31 = { class: "card-body" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { class: "dropdown" }
const _hoisted_34 = {
  class: "h5 dropdown-toggle",
  "data-toggle": "dropdown",
  style: {"white-space":"normal"}
}
const _hoisted_35 = {
  class: "dropdown-menu",
  style: {"max-height":"300px","overflow-y":"auto"}
}
const _hoisted_36 = { class: "input-group px-3 mb-1" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "list-group mt-2" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { key: 1 }
const _hoisted_42 = { class: "dropdown" }
const _hoisted_43 = {
  class: "h5 dropdown-toggle",
  "data-toggle": "dropdown",
  style: {"white-space":"normal"}
}
const _hoisted_44 = {
  class: "dropdown-menu",
  style: {"max-height":"300px","overflow-y":"auto"}
}
const _hoisted_45 = { class: "input-group px-3 mb-1" }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = { class: "list-group mt-2" }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = { key: 0 }
const _hoisted_50 = {
  class: "col-lg-7 offset-lg-1 col-md-9 col-sm-8 col-xs-12",
  style: {"padding-bottom":"100px"}
}
const _hoisted_51 = { key: 0 }
const _hoisted_52 = {
  class: "text-center lead",
  style: {"font-size":"1.5rem"}
}
const _hoisted_53 = { class: "card card-collapsable mt-1" }
const _hoisted_54 = {
  id: "cardQuestion",
  class: "card-body collapse show pt-4"
}
const _hoisted_55 = { class: "mt-3" }
const _hoisted_56 = {
  class: "mt-4",
  style: {"min-height":"500px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MeetingStarter = _resolveComponent("MeetingStarter")!
  const _component_MeetingStopper = _resolveComponent("MeetingStopper")!
  const _component_PanelOpener = _resolveComponent("PanelOpener")!
  const _component_PanelCloser = _resolveComponent("PanelCloser")!
  const _component_SurveyAccessLinks = _resolveComponent("SurveyAccessLinks")!
  const _component_AttributeDescriptionDialog = _resolveComponent("AttributeDescriptionDialog")!
  const _component_AlternativeDetailsDialog = _resolveComponent("AlternativeDetailsDialog")!
  const _component_DisagreementsDialog = _resolveComponent("DisagreementsDialog")!
  const _component_PortfolioOrDecisionNavigation = _resolveComponent("PortfolioOrDecisionNavigation")!
  const _component_HostVoteEditor = _resolveComponent("HostVoteEditor")!
  const _component_VotesBrowser = _resolveComponent("VotesBrowser")!
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_MeetingStarter, {
      viewModel: _ctx.meetingStarter,
      onStartMeeting: _ctx.StartMeeting,
      onOpenSurvey: _ctx.handleOpenPanelAccessCommand,
      onCloseSurvey: _ctx.handleClosePanelAccessCommand,
      onToggleAutoReveal: _ctx.ToggleAutoRevealCommand,
      onToggleNamesRevealed: _ctx.ToggleNamesRevealedCommand,
      onShowAccessLinks: _ctx.ShowAccessLinksCommand
    }, null, 8 /* PROPS */, ["viewModel", "onStartMeeting", "onOpenSurvey", "onCloseSurvey", "onToggleAutoReveal", "onToggleNamesRevealed", "onShowAccessLinks"]),
    _createVNode(_component_MeetingStopper, {
      viewModel: _ctx.meetingStopper,
      onStopMeeting: _ctx.StopMeeting,
      onOpenSurvey: _ctx.handleOpenPanelAccessCommand,
      onCloseSurvey: _ctx.handleClosePanelAccessCommand
    }, null, 8 /* PROPS */, ["viewModel", "onStopMeeting", "onOpenSurvey", "onCloseSurvey"]),
    _createVNode(_component_PanelOpener, {
      viewModel: _ctx.panelOpener,
      onOpenPanel: _ctx.handleOpenPanelAccessCommand,
      onShowLinks: _ctx.ShowAccessLinksCommand
    }, null, 8 /* PROPS */, ["viewModel", "onOpenPanel", "onShowLinks"]),
    _createVNode(_component_PanelCloser, {
      viewModel: _ctx.panelCloser,
      onCloseAccess: _ctx.handleClosePanelAccessCommand
    }, null, 8 /* PROPS */, ["viewModel", "onCloseAccess"]),
    _createVNode(_component_SurveyAccessLinks, {
      viewModel: _ctx.surveyAccessLinks,
      onSendEmail: _ctx.handleSendEmailCommand,
      onDownloadLinks: _ctx.downloadLinks
    }, null, 8 /* PROPS */, ["viewModel", "onSendEmail", "onDownloadLinks"]),
    _createVNode(_component_AttributeDescriptionDialog, { viewModel: _ctx.attributeDescriptionDialog }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(_component_AlternativeDetailsDialog, { viewModel: _ctx.alternativeDetailsDialog }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(_component_DisagreementsDialog, {
      viewModel: _ctx.disagreementsDialog,
      onSwitchQuestion: _ctx.SwitchQuestion
    }, null, 8 /* PROPS */, ["viewModel", "onSwitchQuestion"]),
    _createVNode(_component_PortfolioOrDecisionNavigation, {
      workspaceId: _ctx.workspaceId,
      projectId: _ctx.projectId
    }, null, 8 /* PROPS */, ["workspaceId", "projectId"]),
    (!_ctx.initialized)
      ? (_openBlock(), _createElementBlock("h3", _hoisted_1, [...(_cache[22] || (_cache[22] = [
          _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
          _createTextVNode(" Loading... ", -1 /* CACHED */)
        ]))]))
      : _createCommentVNode("v-if", true),
    (_ctx.initialized && _ctx.questionsCount === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[24] || (_cache[24] = _createElementVNode("h5", { class: "card-title" }, "No questions", -1 /* CACHED */)),
              _cache[25] || (_cache[25] = _createElementVNode("p", { class: "card-text lead" }, "Sorry. This panel has no questions.", -1 /* CACHED */)),
              _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_5, [...(_cache[23] || (_cache[23] = [
                _createTextVNode("Go back", -1 /* CACHED */)
              ]))])), [
                [_directive_sanitizedHref, _ctx.BackUrl]
              ])
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.initialized && _ctx.questionsCount > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("nav", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.PreviousQuestionCommand && _ctx.PreviousQuestionCommand(...args))),
                type: "button",
                class: "btn btn-secondary"
              }, [...(_cache[26] || (_cache[26] = [
                _createElementVNode("i", {
                  class: "fa fa-chevron-left",
                  "aria-hidden": "true"
                }, null, -1 /* CACHED */),
                _createTextVNode(),
                _createElementVNode("span", null, "Prev question", -1 /* CACHED */)
              ]))]),
              (!_ctx.AllQuestionsAnswered)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.NextUnansweredQuestionCommand && _ctx.NextUnansweredQuestionCommand(...args))),
                    type: "button",
                    class: "btn btn-warning",
                    title: "Go to next unanswered question"
                  }, " Next unanswered "))
                : _createCommentVNode("v-if", true),
              (_ctx.AllQuestionsAnswered)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.AllDoneCommand && _ctx.AllDoneCommand(...args))),
                    type: "button",
                    class: "btn btn-success",
                    title: "Go to next unanswered question"
                  }, " All done "))
                : _createCommentVNode("v-if", true),
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.NextQuestionCommand && _ctx.NextQuestionCommand(...args))),
                type: "button",
                class: "btn btn-secondary"
              }, [...(_cache[27] || (_cache[27] = [
                _createElementVNode("span", null, "Next question", -1 /* CACHED */),
                _createTextVNode(),
                _createElementVNode("i", {
                  class: "fa fa-chevron-right",
                  "aria-hidden": "true"
                }, null, -1 /* CACHED */)
              ]))])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("h6", _hoisted_12, [
                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_13, [...(_cache[28] || (_cache[28] = [
                    _createElementVNode("i", {
                      class: "fa fa-angle-double-left",
                      "aria-hidden": "true"
                    }, null, -1 /* CACHED */),
                    _createTextVNode(" Back ", -1 /* CACHED */)
                  ]))])), [
                    [_directive_sanitizedHref, _ctx.BackUrl]
                  ])
                ]),
                _createElementVNode("h1", _hoisted_14, "Panel: " + _toDisplayString(_ctx.Name), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_15, [
                (!_ctx.MeetingStarted)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-success mr-1",
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.ShowMeetingStarterCommand && _ctx.ShowMeetingStarterCommand(...args)))
                      }, "Start Meeting"),
                      (!_ctx.SurveyStarted)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "btn btn-outline-secondary mr-1",
                            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.ShowSurveyOpenerCommand && _ctx.ShowSurveyOpenerCommand(...args)))
                          }, "Open Survey"))
                        : _createCommentVNode("v-if", true),
                      (_ctx.SurveyStarted)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            class: "btn btn-outline-secondary mr-1",
                            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.ShowSurveyCloserCommand && _ctx.ShowSurveyCloserCommand(...args)))
                          }, "Close Survey"))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-outline-secondary mr-1",
                        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.ShowAccessLinksCommand && _ctx.ShowAccessLinksCommand(...args)))
                      }, "Access links"),
                      _createElementVNode("div", _hoisted_17, [
                        _cache[29] || (_cache[29] = _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-outline-secondary dropdown-toggle",
                          "data-toggle": "dropdown"
                        }, " Analyze votes ", -1 /* CACHED */)),
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.ShowDisagreementsReportCommand && _ctx.ShowDisagreementsReportCommand(...args)))
                          }, "Disagreements")
                        ])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                (_ctx.MeetingStarted)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-warning",
                          onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.ToggleVotesRevealedCommand && _ctx.ToggleVotesRevealedCommand(...args)))
                        }, [
                          _createElementVNode("i", {
                            class: _normalizeClass(["fa-regular fa-fw", _ctx.VotesRevealed ? 'fa-square-check' : 'fa-square'])
                          }, null, 2 /* CLASS */),
                          _cache[30] || (_cache[30] = _createTextVNode(" Reveal votes ", -1 /* CACHED */))
                        ]),
                        _cache[33] || (_cache[33] = _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-warning dropdown-toggle dropdown-toggle-split",
                          "data-toggle": "dropdown"
                        }, null, -1 /* CACHED */)),
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("a", {
                            class: "dropdown-item px-1",
                            onClick: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.ToggleAutoRevealCommand && _ctx.ToggleAutoRevealCommand(...args)), ["stop","prevent"]))
                          }, [
                            _createElementVNode("i", {
                              class: _normalizeClass(["fa-regular fa-fw", _ctx.AutoRevealEnabled ? 'fa-square-check' : 'fa-square'])
                            }, null, 2 /* CLASS */),
                            _cache[31] || (_cache[31] = _createTextVNode(" Auto reveal ", -1 /* CACHED */))
                          ]),
                          _createElementVNode("a", {
                            class: "dropdown-item px-1",
                            onClick: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.ToggleNamesRevealedCommand && _ctx.ToggleNamesRevealedCommand(...args)), ["stop","prevent"]))
                          }, [
                            _createElementVNode("i", {
                              class: _normalizeClass(["fa-regular fa-fw", !_ctx.NamesRevealed ? 'fa-square-check' : 'fa-square'])
                            }, null, 2 /* CLASS */),
                            _cache[32] || (_cache[32] = _createTextVNode(" Anonymous ", -1 /* CACHED */))
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _cache[34] || (_cache[34] = _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-outline-secondary dropdown-toggle",
                          "data-toggle": "dropdown"
                        }, " Analyze votes ", -1 /* CACHED */)),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.ShowDisagreementsReportCommand && _ctx.ShowDisagreementsReportCommand(...args)))
                          }, "Disagreements")
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _cache[36] || (_cache[36] = _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-outline-secondary dropdown-toggle",
                          "data-toggle": "dropdown"
                        }, " Actions ", -1 /* CACHED */)),
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.ShowMeetingStopperCommand && _ctx.ShowMeetingStopperCommand(...args)))
                          }, "Stop Meeting"),
                          _cache[35] || (_cache[35] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                          (!_ctx.SurveyStarted)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                class: "dropdown-item",
                                onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.ShowSurveyOpenerCommand && _ctx.ShowSurveyOpenerCommand(...args)))
                              }, "Open Survey"))
                            : _createCommentVNode("v-if", true),
                          (_ctx.SurveyStarted)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                class: "dropdown-item",
                                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.ShowSurveyCloserCommand && _ctx.ShowSurveyCloserCommand(...args)))
                              }, "Close Survey"))
                            : _createCommentVNode("v-if", true),
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.ShowAccessLinksCommand && _ctx.ShowAccessLinksCommand(...args)))
                          }, "Access links")
                        ])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _cache[49] || (_cache[49] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 60px"} }, null, -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _cache[37] || (_cache[37] = _createTextVNode(" Questions ", -1 /* CACHED */)),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.ProgressDescription), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("a", {
                        class: "text-dark",
                        onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.SwitchQuestionsOrderCommand && _ctx.SwitchQuestionsOrderCommand(...args)))
                      }, _toDisplayString(_ctx.QuestionsOrderLabel), 1 /* TEXT */)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    (_ctx.QuestionsOrder == 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("a", _hoisted_34, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.CurrentAttributeLabel), 1 /* TEXT */)
                            ]),
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("div", _hoisted_36, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "search",
                                  placeholder: "Search...",
                                  class: "form-control",
                                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.SearchPhrase) = $event))
                                }, null, 512 /* NEED_PATCH */), [
                                  [_vModelText, _ctx.SearchPhrase]
                                ]),
                                _cache[38] || (_cache[38] = _createElementVNode("span", { class: "input-group-append" }, [
                                  _createElementVNode("span", { class: "input-group-text" }, [
                                    _createElementVNode("i", {
                                      class: "fa-solid fa-magnifying-glass",
                                      "aria-hidden": "true"
                                    })
                                  ])
                                ], -1 /* CACHED */))
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.AttributesView, (attr) => {
                                return (_openBlock(), _createElementBlock("a", {
                                  class: "dropdown-item",
                                  onClick: ($event: any) => (_ctx.SwitchToAttributeCommand(attr))
                                }, [
                                  _createTextVNode(_toDisplayString(attr.Name) + " ", 1 /* TEXT */),
                                  _cache[39] || (_cache[39] = _createElementVNode("br", null, null, -1 /* CACHED */))
                                ], 8 /* PROPS */, _hoisted_37))
                              }), 256 /* UNKEYED_FRAGMENT */))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_38, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.QuestionsView, (q) => {
                              return (_openBlock(), _createElementBlock("a", {
                                class: _normalizeClass(["list-group-item list-group-item-action", { 'bg-secondary text-white': _ctx.CurrentQuestionId === q.QuestionId }]),
                                onClick: ($event: any) => (_ctx.SwitchToQuestionCommand(q))
                              }, [
                                _createElementVNode("i", {
                                  class: _normalizeClass(_ctx.getStatusCss(q))
                                }, null, 2 /* CLASS */),
                                _createTextVNode(" " + _toDisplayString(q.AlternativeName) + " ", 1 /* TEXT */),
                                (q.GroupVoteValue != null)
                                  ? (_openBlock(), _createElementBlock("small", _hoisted_40, [
                                      _cache[40] || (_cache[40] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                                      _createTextVNode("Value: " + _toDisplayString(q.GroupVoteValue), 1 /* TEXT */)
                                    ]))
                                  : _createCommentVNode("v-if", true)
                              ], 10 /* CLASS, PROPS */, _hoisted_39))
                            }), 256 /* UNKEYED_FRAGMENT */))
                          ])
                        ]))
                      : _createCommentVNode("v-if", true),
                    (_ctx.QuestionsOrder == 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                          _createElementVNode("div", _hoisted_42, [
                            _createElementVNode("a", _hoisted_43, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.CurrentAlternativeLabel), 1 /* TEXT */)
                            ]),
                            _createElementVNode("div", _hoisted_44, [
                              _createElementVNode("div", _hoisted_45, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "search",
                                  placeholder: "Search...",
                                  class: "form-control",
                                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.SearchPhrase) = $event))
                                }, null, 512 /* NEED_PATCH */), [
                                  [_vModelText, _ctx.SearchPhrase]
                                ]),
                                _cache[41] || (_cache[41] = _createElementVNode("span", { class: "input-group-append" }, [
                                  _createElementVNode("span", { class: "input-group-text" }, [
                                    _createElementVNode("i", {
                                      class: "fa-solid fa-magnifying-glass",
                                      "aria-hidden": "true"
                                    })
                                  ])
                                ], -1 /* CACHED */))
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.AlternativesView, (a) => {
                                return (_openBlock(), _createElementBlock("a", {
                                  class: "dropdown-item",
                                  onClick: ($event: any) => (_ctx.SwitchToAlternativeCommand(a))
                                }, [
                                  _createTextVNode(_toDisplayString(a.Name), 1 /* TEXT */),
                                  _cache[42] || (_cache[42] = _createElementVNode("br", null, null, -1 /* CACHED */))
                                ], 8 /* PROPS */, _hoisted_46))
                              }), 256 /* UNKEYED_FRAGMENT */))
                            ]),
                            _createElementVNode("div", _hoisted_47, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.QuestionsView, (q) => {
                                return (_openBlock(), _createElementBlock("a", {
                                  class: _normalizeClass(["list-group-item list-group-item-action", { 'bg-secondary text-white': _ctx.CurrentQuestionId === q.QuestionId }]),
                                  onClick: ($event: any) => (_ctx.SwitchToQuestionCommand(q))
                                }, [
                                  _createElementVNode("i", {
                                    class: _normalizeClass(_ctx.getStatusCss(q))
                                  }, null, 2 /* CLASS */),
                                  _createTextVNode(" " + _toDisplayString(q.AttributeName) + " ", 1 /* TEXT */),
                                  (q.GroupVoteValue != null)
                                    ? (_openBlock(), _createElementBlock("small", _hoisted_49, [
                                        _cache[43] || (_cache[43] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                                        _createTextVNode("Value: " + _toDisplayString(q.GroupVoteValue), 1 /* TEXT */)
                                      ]))
                                    : _createCommentVNode("v-if", true)
                                ], 10 /* CLASS, PROPS */, _hoisted_48))
                              }), 256 /* UNKEYED_FRAGMENT */))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("v-if", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_50, [
                (_ctx.Question)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                      _createElementVNode("p", _hoisted_52, [
                        _cache[44] || (_cache[44] = _createTextVNode(" How would you rate: ", -1 /* CACHED */)),
                        _createElementVNode("a", {
                          class: "text-primary",
                          title: "Show description",
                          onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.ShowAlternativeDetailsCommand(_ctx.Question.AlternativeId)))
                        }, _toDisplayString(_ctx.Question.AlternativeName), 1 /* TEXT */),
                        _cache[45] || (_cache[45] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                        _cache[46] || (_cache[46] = _createTextVNode(" in the context of: ", -1 /* CACHED */)),
                        _createElementVNode("a", {
                          class: "text-primary",
                          title: "Show description",
                          onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.ShowAttributeDetailsCommand(_ctx.Question.AttributeId)))
                        }, _toDisplayString(_ctx.Question.AttributeName), 1 /* TEXT */),
                        _cache[47] || (_cache[47] = _createTextVNode("? ", -1 /* CACHED */))
                      ]),
                      _createElementVNode("div", _hoisted_53, [
                        _cache[48] || (_cache[48] = _createElementVNode("div", {
                          class: "card-header pointer",
                          "data-toggle": "collapse",
                          href: "#cardQuestion"
                        }, " Group vote ", -1 /* CACHED */)),
                        _createElementVNode("div", _hoisted_54, [
                          _createVNode(_component_HostVoteEditor, {
                            readModel: _ctx.Question,
                            onUpdateComment: _ctx.saveComment,
                            onUpdateValue: _ctx.saveValue
                          }, null, 8 /* PROPS */, ["readModel", "onUpdateComment", "onUpdateValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("div", _hoisted_56, [
                          _createVNode(_component_VotesBrowser, {
                            AlternativeName: _ctx.Question.AlternativeName,
                            HasScale: _ctx.Question.HasScale,
                            Entries: _ctx.Question.Entries,
                            ScaleLevels: _ctx.Question.ScaleLevels
                          }, null, 8 /* PROPS */, ["AlternativeName", "HasScale", "Entries", "ScaleLevels"])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}